import React from 'react'
import { useRandomId } from '@fs/zion-frontend-friends'

export default function FaceFeature({ scaleX, scale, fill, spacing, rotation, gradient, verticalOffset }) {
  const randomGradientId1 = `_${useRandomId()}`
  const randomGradientId2 = `_${useRandomId()}`

  const leftTransformOrigin = '11.1971 7.6166'
  const rightTransformOrigin = '42.2267 7.6166'

  return (
    <g transform={`scale(${scaleX},1) translate(0,${verticalOffset})`}>
      <g
        transform={`translate(${-spacing}) rotate(${rotation}) scale(${scale},${scale})`}
        transform-origin={leftTransformOrigin}
      >
        <path
          d="M0.342033 13.2267C0.342033 13.2267 3.72203 8.60666 7.34203 8.60666C10.962 8.60666 20.462 12.7866 22.332 9.92664C24.202 7.06664 21.812 3.31666 21.812 3.31666C21.812 3.31666 12.342 1.22665 6.92204 2.21665C4.21204 2.71665 1.43204 4.98666 0.472038 7.60666C-0.507961 10.2367 0.342033 13.2267 0.342033 13.2267Z"
          fill={`url(#${randomGradientId1})`}
        />
        <path
          d="M0.462128 7.61657C0.462128 7.61657 3.84213 2.99658 7.46213 2.99658C11.0821 2.99658 18.6521 5.74658 18.6521 5.74658L21.9321 3.32656C21.9321 3.32656 13.4221 0.136582 8.00213 1.12658C2.57213 2.10658 0.462128 7.61657 0.462128 7.61657Z"
          fill={fill}
        />
      </g>
      <g
        transform={`translate(${spacing}) rotate(${-rotation}) scale(${scale},${scale})`}
        transform-origin={rightTransformOrigin}
      >
        <path
          d="M53.0813 13.2267C53.0813 13.2267 49.7013 8.60666 46.0813 8.60666C42.4613 8.60666 32.9613 12.7866 31.0913 9.92664C29.2213 7.06664 31.6113 3.31666 31.6113 3.31666C31.6113 3.31666 41.0813 1.22665 46.5013 2.21665C49.2113 2.71665 51.9913 4.98666 52.9513 7.60666C53.9313 10.2367 53.0813 13.2267 53.0813 13.2267Z"
          fill={`url(#${randomGradientId2})`}
        />
        <path
          d="M52.9617 7.61657C52.9617 7.61657 49.5817 2.99658 45.9617 2.99658C42.3417 2.99658 34.7717 5.74658 34.7717 5.74658L31.4917 3.32656C31.4917 3.32656 40.0017 0.136582 45.4217 1.12658C50.8517 2.10658 52.9617 7.61657 52.9617 7.61657Z"
          fill={fill}
        />

        <defs>
          <linearGradient
            id={randomGradientId1}
            x1="41.9"
            y1="15.1767"
            x2="41.9"
            y2="4.92961"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0.2877" stopColor={gradient[1]} stopOpacity="0" />
            <stop offset="0.8775" stopColor={gradient[0]} />
          </linearGradient>
          <linearGradient
            id={randomGradientId2}
            x1="11.5233"
            y1="15.1767"
            x2="11.5233"
            y2="4.92961"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0.2877" stopColor={gradient[1]} stopOpacity="0" />
            <stop offset="0.8775" stopColor={gradient[0]} />
          </linearGradient>
        </defs>
      </g>
    </g>
  )
}
